export const COVER_SIZE = { width: 1200, height: 630 };
export const LOGO_SIZE = { width: 600, height: 600, fit: "contain" };

export function resizeImage(file, { width, height, fit = "cover" } = COVER_SIZE) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      URL.revokeObjectURL(url);
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      if (fit === "contain") {
        const scale = Math.min(width / img.width, height / img.height);
        const dw = Math.round(img.width * scale);
        const dh = Math.round(img.height * scale);
        ctx.drawImage(img, Math.round((width - dw) / 2), Math.round((height - dh) / 2), dw, dh);
        resolve(canvas.toDataURL("image/png"));
        return;
      }
      const scale = Math.max(width / img.width, height / img.height);
      const sw = width / scale;
      const sh = height / scale;
      const sx = (img.width - sw) / 2;
      const sy = (img.height - sh) / 2;
      ctx.drawImage(img, sx, sy, sw, sh, 0, 0, width, height);
      resolve(canvas.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read image"));
    };
    img.src = url;
  });
}
